// NATIVE 


// INSTALLED 
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, Divider } from '@mui/material';


// CUSTOM 
import { useEffect, useState } from 'react';
import { mtDividerUpTable } from '../../commons';
import { hasPemissions } from '../../commons/utils';
import { IDatosBasicos } from '../../commons/interfaces';
import { TableCustomers } from '../../components/tables';
import { alertInformativo } from '../../commons/texts/textAlertsInformativos';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';






/**
 * Component representing the "Compania" page.
 *
 * This component fetches the company data from the Redux store and checks if the user has permissions to create a new company.
 * If the user has the necessary permissions, a "Crear Compañia" button is displayed.
 * 
 * @component
 * 
 * @returns {JSX.Element} The rendered component.
 * 
 * @example
 * <Compania />
 * 
 * @remarks
 * - Uses Redux to fetch company data.
 * - Uses useState to manage the creation permission state.
 * - Uses useEffect to check permissions on component mount.
 * - Displays a breadcrumb and title component.
 * - Conditionally renders a "Crear Compañia" button based on permissions and company data.
 * - Displays a divider and a table of customers.
 */
export const Compania = () => {

  // REDUX
  const { company }:IDatosBasicos  = useSelector( (state:any) => state.company );  

  
  // USE STATE 
  const [canCreate, setCanCreate]     = useState<boolean>(false);


  // USE EFFECT 
  useEffect(() => {
      checkCanCreate();
  }, []);


  // CONST FUNCTIONS 
  const checkCanCreate = async() => {
        
    const hasPermissionsEdit = await hasPemissions('modulo.configuracion', 'modulo.compania', 'create' );
  
    if ( hasPermissionsEdit ) {
         setCanCreate(true);
    }


  }
  

  return (
    <>
      
        <BreadCrumbsAndTitle 
                      title="Compañia" 
                      mainModule="configuracion" 
                      parent="Compañia"
                      action="" />

        {
          canCreate && Object.keys(company).length == 0
                                ?   <div style={{ display: 'flex', justifyContent: 'end'}}>
                                        <Button component={Link} to={'/configuracion/crear-compania'}  variant='contained' sx={{ marginBottom: 3 }}>Crear Compañia</Button>
                                    </div>
                                : ''
        }

        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.compania} />
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>

        <TableCustomers />
    </>
  )
}



